import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  wrapper: {
    marginTop: 42,
  },
  title: {
    marginBottom: 30
  },
  button: {
    width: '100%',
    marginTop: 36,
    marginBottom: theme.spacing(3)
  },
  inputIndent: {
    marginBottom: theme.spacing(3)
  },
  passwordIcon: {
    fontSize: 18
  }
}));

export default useStyles;
